
























import Vue from "vue";
import { FieldInterface } from "@/types";

export default Vue.extend({
  name: "ItemList",
  props: {
    itemList: Array,
    isDefaultOpen: Boolean,
    showFlags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MAX_LIST_HEIGHT,
      currentHighlight: 0,
      listHeight: 0,
      isOpen: this.isDefaultOpen,
    };
  },
  mounted() {
    this.listHeight = ((this.$refs.itemList as any) as HTMLElement).getBoundingClientRect().height;
    this.isOpen = false;
  },
  methods: {
    click(item: any) {
      this.$emit("selectOption", item);
    },
    enableKeyboardControl() {
      this.disableKeyboardControl();
      document.addEventListener("keydown", this.keyboardControl);
    },
    disableKeyboardControl() {
      document.removeEventListener("keydown", this.keyboardControl);
    },
    scrollToHighlighted() {
      const itemList = this.$refs.itemList as HTMLElement;
      if (itemList.childNodes.length > 0 && this.currentHighlight < itemList.childNodes.length) {
        const item = itemList.childNodes[this.currentHighlight] as HTMLElement;

        itemList.scrollTo({
          top: item.offsetTop,
        });
      }
    },

    setHighlighted(index: number, updateScroll: boolean = true) {
      if (index < this.itemList.length && index >= 0) {
        if (!this.currentHighlight) {
          this.currentHighlight = 0;
        }

        const itemList: HTMLElement = this.$refs.itemList as HTMLElement;
        let itemListViewportStart = itemList.scrollTop;
        let itemListViewportEnd = itemList.scrollTop + itemList.getBoundingClientRect().height;
        let highlightedItem: HTMLElement = itemList.childNodes[this.currentHighlight] as HTMLElement;

        // scroll to highlighted element before change if it's outside of list viewport. Highlighted item can be undefined if itemList was filtered
        if (
          highlightedItem &&
          updateScroll &&
          (highlightedItem.offsetTop > itemListViewportEnd || highlightedItem.offsetTop < itemListViewportStart)
        ) {
          this.scrollToHighlighted();
        }

        this.currentHighlight = index;

        if (updateScroll) {
          // scroll list by one if new highlighted element is outside new viewport
          itemListViewportStart = itemList.scrollTop;
          itemListViewportEnd = itemList.scrollTop + itemList.getBoundingClientRect().height;
          highlightedItem = itemList.childNodes[this.currentHighlight] as HTMLElement;

          const highlightedItemHeight = highlightedItem.getBoundingClientRect().height;

          if (highlightedItem.offsetTop > itemListViewportEnd - highlightedItemHeight) {
            itemList.scrollBy(0, highlightedItemHeight);
          } else if (highlightedItem.offsetTop < itemListViewportStart) {
            itemList.scrollBy(0, highlightedItemHeight * -1);
          }
        }
      }
    },

    keyboardControl(evt: KeyboardEvent) {
      if (evt.key === Key.UP || evt.key === Key.DOWN) {
        evt.preventDefault();
      }

      if (!this.currentHighlight || !this.itemList[this.currentHighlight]) {
        this.currentHighlight = 0;
      }

      switch (evt.key) {
        case Key.UP:
          if (this.currentHighlight > 0) {
            this.setHighlighted(this.currentHighlight - 1);
          }
          break;
        case Key.DOWN:
          if (this.currentHighlight < this.itemList.length) {
            this.setHighlighted(this.currentHighlight + 1);
          }
          break;
        case Key.ENTER:
          evt.preventDefault();
          this.$emit("selectOption", this.itemList[this.currentHighlight] as FieldInterface);
          break;
      }
    },

    getItemNodes(): NodeList {
      return (this.$refs.itemList as HTMLElement).childNodes;
    },
  },
  watch: {
    isDefaultOpen(newValue) {
      this.isOpen = newValue;
      this.scrollToHighlighted();
      this.disableKeyboardControl();

      if (newValue) {
        this.enableKeyboardControl();

        this.listHeight = ((this.$refs.itemList as any) as HTMLElement).getBoundingClientRect().height;
      }
    },
  },
  beforeDestroy() {
    this.disableKeyboardControl();
  },
});

enum Key {
  UP = "ArrowUp",
  DOWN = "ArrowDown",
  ENTER = "Enter",
}

const MAX_LIST_HEIGHT = window.innerHeight < 500 ? 140 : 250;
